import { Drawer } from '@/views/interfaces/vuetify/drawer.interface';
import { Roles } from '@/services/Roles';

export default (): Drawer[] => ([
  {
    group: '/scrums',
    icon: 'mdi-account',
    title: 'dev_scrum',
    scope: 'scrums:*',
    children: [
      {
        title: 'list_scrums',
        to: '/',
        scope: Roles.SCRUM_AUDITS_READ,
        icon: 'mdi-account-details',
      },
      {
        title: 'dev_scrum_settings',
        to: '/settings',
        icon: 'mdi-account-multiple-plus-outline',
        scope: Roles.SCRUM_SETTINGS_CREATE,
      },
    ],
  },
  {
    group: '/server',
    icon: 'mdi-server',
    title: 'server',
    scope: 'server:*',
    children: [
      {
        title: 'server_all',
        to: '/',
        scope: Roles.SERVER_SERVER_READ,
        icon: 'mdi-server',
      },
      {
        title: 'server_add',
        to: '/create',
        scope: Roles.SERVER_SERVER_CREATE,
        icon: 'mdi-server-plus',
      },
    ],
  },
  {
    group: '/sms',
    icon: 'mdi-message-processing',
    title: 'sms',
    scope: 'server:*',
    children: [
      {
        title: 'sms_add',
        to: '/messages/create',
        scope: Roles.SERVER_SERVER_READ,
        icon: 'mdi-message',
      },
      {
        title: 'template_add',
        to: '/templates/create',
        scope: Roles.SERVER_SERVER_CREATE,
        icon: 'mdi-message-plus',
      },
      {
        title: 'template_list',
        to: '/templates',
        scope: Roles.SERVER_SERVER_READ,
        icon: 'mdi-forum',
      },
      {
        title: 'sms_list',
        to: '/messages',
        scope: Roles.SERVER_SERVER_READ,
        icon: 'mdi-forum',
      },

    ],
  },
  {
    group: '/ipset',
    icon: 'mdi-ip',
    title: 'ipset',
    scope: 'ipset:*',
    children: [
      {
        title: 'ipset_lists',
        to: '/sets',
        scope: Roles.IPSET_IPSET_READ,
        icon: 'mdi-format-list-text',
      },
      {
        title: 'ipset_set_create',
        to: '/sets/create',
        scope: Roles.IPSET_IPSET_CREATE,
        icon: 'mdi-text-box-plus-outline',
      },
    ],
  },
  // {
  //   group: '/vhost',
  //   icon: 'mdi-cloud-outline',
  //   title: 'vhost',
  //   scope: 'vhost:*',
  //   children: [
  //     {
  //       title: 'vhost_list',
  //       to: '/',
  //       scope: Roles.VHOST_VHOST_READ,
  //       icon: 'mdi-cloud-print-outline',
  //     },
  //     {
  //       title: 'vhost_create',
  //       to: '/create',
  //       scope: Roles.VHOST_VHOST_CREATE,
  //       icon: 'mdi-cloud-upload-outline',
  //     },
  //   ],
  // },
  {
    group: '/websites',
    icon: 'mdi-cloud',
    title: 'websites',
    scope: 'website:*',
    children: [
      {
        title: 'websites_all',
        to: '/',
        scope: Roles.WEBSITE_WEBSITE_READ,
        icon: 'mdi-format-list-text',
      },
      {
        title: 'website_groups',
        to: '/groups',
        scope: Roles.WEBSITE_WEBSITE_READ,
        icon: 'mdi-cloud-print',
      },
    ],
  },
  {
    group: '/website-migrations',
    icon: 'mdi-cloud-arrow-right',
    title: 'website_migrations',
    scope: 'website:*',
    children: [
      {
        title: 'website_migrations_list',
        to: '/',
        scope: Roles.WEBSITE_MIGRATIONS_READ,
        icon: 'mdi-cloud-print',
      },
      {
        title: 'groups_migrations_list',
        to: '/groups',
        scope: Roles.WEBSITE_MIGRATIONS_READ,
        icon: 'mdi-clouds',
      },
      {
        title: 'databases_migrations_list',
        to: '/databases',
        scope: Roles.WEBSITE_MIGRATIONS_READ,
        icon: 'mdi-database-arrow-right',
      },
    ],
  },
  {
    group: '/website-orchestrator',
    icon: 'mdi-sitemap',
    title: 'website_orchestrator',
    scope: 'website:*',
    children: [
      {
        title: 'resources',
        to: '/',
        scope: Roles.WEBSITE_WEBSITE_READ,
        icon: 'mdi-package-variant',
      },
    ],
  },
  {
    group: '/plans',
    icon: 'mdi-clipboard-text-outline',
    title: 'plans',
    scope: 'system-user:*',
    children: [
      {
        title: 'all_plans',
        to: '/',
        scope: Roles.SYSTEM_USER_PLAN_READ,
        icon: 'mdi-clipboard-text-outline',
      },
    ],
  },
  {
    group: '/vhost',
    icon: 'mdi-cloud-outline',
    title: 'vhost',
    scope: 'vhost:*',
    children: [
      {
        title: 'cdn_vhost_list',
        to: '/cdn',
        scope: Roles.VHOST_VHOST_READ,
        icon: 'mdi-cloud-print-outline',
      },
      {
        title: 'origin_vhost_list',
        to: '/origin',
        scope: Roles.VHOST_VHOST_CREATE,
        icon: 'mdi-cloud-print',
      },
    ],
  },
  {
    group: '/dns',
    icon: 'mdi-routes',
    title: 'dns',
    scope: 'dns:*',
    children: [
      {
        title: 'dns_zones',
        to: '/',
        scope: Roles.DNS_ZONE_READ,
        icon: 'mdi-format-list-text',
      },
      {
        title: 'dns_zone_create',
        to: '/zone/create',
        scope: Roles.DNS_ZONE_CREATE,
        icon: 'mdi-text-box-plus-outline',
      },
      {
        title: 'dns_departments',
        to: '/departments',
        scope: Roles.DNS_DEPARTMENT,
        icon: 'mdi-account-group',
      },
    ],
  },
  {
    group: '/ssl',
    icon: 'mdi-certificate-outline',
    title: 'ssl',
    scope: 'ssl:*',
    children: [
      {
        title: 'certificate_all',
        to: '/',
        scope: Roles.SSL_CERT_READ,
        icon: 'mdi-format-list-numbered',
      },
      {
        title: 'certificate_create',
        to: '/create',
        scope: Roles.SSL_CERT_CREATE,
        icon: 'mdi-file-plus-outline',
      },
    ],
  },
  {
    group: '/system-users',
    icon: 'mdi-account-cog',
    title: 'system_users',
    scope: 'system-user:*',
    children: [
      {
        title: 'system_users_list',
        to: '/list',
        scope: Roles.SYSTEM_USER_READ,
        icon: 'mdi-account-details',
        toFixed: '/system-users/list',
      },
      {
        title: 'system_user_create',
        to: '/create',
        scope: Roles.SYSTEM_USER_CREATE,
        icon: 'mdi-account-plus',
        toFixed: '/system-users/create',
      },
    ],
  },
  {
    group: '/databases',
    icon: 'mdi-database',
    title: 'databases',
    scope: 'database:*',
    children: [
      {
        title: 'database_list',
        to: '/list',
        scope: Roles.DATABASE_DATABASE_READ,
        icon: 'mdi-database-search',
        toFixed: '/databases/list',
      },
      {
        title: 'database_create',
        to: '/create',
        scope: Roles.DATABASE_DATABASE_CREATE,
        icon: 'mdi-database-plus',
        toFixed: '/databases/create',
      },
      {
        title: 'database_users_list',
        to: '/users/list',
        scope: Roles.DATABASE_USER_READ,
        icon: 'mdi-account',
        toFixed: '/databases/users/list',
      },
      {
        title: 'database_users_create',
        to: '/users/create',
        scope: Roles.DATABASE_USER_CREATE,
        icon: 'mdi-account-plus',
        toFixed: '/databases/users/create',
      },
    ],
  },
  {
    group: '/mailboxes',
    icon: 'mdi-mailbox-up-outline',
    title: 'mailboxes',
    scope: 'mailbox:*',
    children: [
      {
        title: 'mailbox_list',
        to: '/',
        scope: Roles.MAILBOX_MAILBOX_READ,
        icon: 'mdi-email-search-outline',
        toFixed: '/mailboxes',
      },
      {
        title: 'mailbox_create',
        to: '/create',
        scope: Roles.MAILBOX_MAILBOX_CREATE,
        icon: 'mdi-email-search-outline',
        toFixed: '/mailboxes/create',
      },
    ],
  },
  {
    group: '/ftp-users',
    icon: 'mdi-file-account-outline',
    title: 'ftp_users',
    scope: 'ftp-user:*',
    children: [
      {
        title: 'ftp_user_list',
        to: '/',
        scope: Roles.FTP_USER_FTP_USER_READ,
        icon: 'mdi-file-search-outline',
        toFixed: '/ftp-users',
      },
      {
        title: 'ftp_user_create',
        to: '/create',
        scope: Roles.FTP_USER_FTP_USER_CREATE,
        icon: 'mdi-file-document-plus-outline',
        toFixed: '/ftp-users/create',
      },
    ],
  },
  {
    group: '/backups',
    icon: 'mdi-file-account-outline',
    title: 'backup_list',
    scope: 'backup:*',
    children: [
      {
        title: 'backup_server_list',
        scope: Roles.BACKUP_SERVER_READ,
        icon: 'mdi-file-search-outline',
        toFixed: '/backups/servers',
      },
      {
        title: 'backup_repository_list',
        scope: Roles.BACKUP_REPO_READ,
        icon: 'mdi-file-search-outline',
        toFixed: '/backups/repositories',
      },
      {
        title: 'backup_list',
        scope: Roles.BACKUP_BACKUP_READ,
        icon: 'mdi-file-search-outline',
        toFixed: '/backups',
      },
      {
        title: 'restore_list',
        scope: Roles.BACKUP_LOGS_READ,
        icon: 'mdi-file-search-outline',
        toFixed: '/restores',
      },
      {
        title: 'schedule_list',
        scope: Roles.BACKUP_SCHEDULE_READ,
        icon: 'mdi-file-search-outline',
        toFixed: '/backups/schedules',
      },
      {
        title: 'task_list',
        scope: Roles.BACKUP_TASK_READ,
        icon: 'mdi-file-search-outline',
        toFixed: '/backups/tasks',
      },
      {
        title: 'backup_repo_locks',
        scope: Roles.BACKUP_REPO_READ,
        icon: 'mdi-file-search-outline',
        toFixed: '/backups/locks',
      }
    ],
  },
  {
    group: '/usage',
    icon: 'mdi-chart-bar',
    title: 'Usage',
    scope: 'quotas:*',
    children: [
      // {
      //   title: 'disk_space',
      //   to: '/disk-space',
      //   scope: Roles.DISK_SPACE_READ,
      //   icon: 'mdi-harddisk',
      // },
      // {
      //   title: 'bandwidth',
      //   to: '/bandwidth',
      //   scope: Roles.BANDWITH_READ,
      //   icon: 'mdi-swap-horizontal',
      // },
      {
        title: 'Usage List',
        to: '/',
        scope: Roles.USAGE_READ,
        icon: 'mdi-pulse',
      },
    ],
  },
  {
    group: '/qc',
    icon: 'mdi-text-box-check',
    title: 'qc',
    scope: 'qa:*',
    children: [
      {
        title: 'chat_list',
        to: '/chats',
        scope: Roles.QA_CHAT_REVIEW,
        icon: 'mdi-archive-outline',
      },
      {
        title: 'chats_queue',
        to: '/chats/queue',
        scope: Roles.QA_CHAT_REVIEW,
        icon: 'mdi-tray-full',
      },
      {
        title: 'ticket_list',
        to: '/tickets',
        scope: Roles.QA_TICKET_READ,
        icon: 'mdi-ticket-confirmation-outline',
      },
      {
        title: 'escalation_list',
        to: '/escalations',
        scope: Roles.QA_ESCALATION_READ,
        icon: 'mdi-clipboard-arrow-up-outline',
      },
      {
        title: 'feedback_list',
        to: '/feedbacks',
        scope: Roles.QA_FEEDBACK_READ,
        icon: 'mdi-message-bookmark-outline',
      },
      {
        title: 'qc_statistics',
        to: '/statistics',
        scope: Roles.QA_STATISTICS_READ,
        icon: 'mdi-chart-line',
      },
      {
        title: 'all_dossiers',
        to: '/dossiers',
        scope: Roles.QA_DOSSIER_COMMENT_READ,
        icon: 'mdi-card-account-details-outline',
      },
    ],
  },
  {
    group: '/qc-settings',
    icon: 'mdi-text-box-check',
    title: 'qc_settings',
    scope: Roles.QA_MANAGER,
    children: [
      {
        title: 'tag_list',
        to: '/tags',
        scope: Roles.QA_TAG_READ,
        icon: 'mdi-tag-outline',
      },
      {
        title: 'score_type_list',
        to: '/score/types',
        toFixed: '/qc-settings/score/types',
        scope: Roles.QA_SCORE_TYPE_READ,
        icon: 'mdi-book-open-page-variant-outline',
      },
      {
        title: 'score_grade_list',
        to: '/score/grades',
        toFixed: '/qc-settings/score/grades',
        scope: Roles.QA_SCORE_GRADE_READ,
        icon: 'mdi-numeric',
      },
      {
        title: 'cron_settings',
        to: '/cron',
        scope: Roles.QA_MANAGER,
        icon: 'mdi-cog-refresh',
      },
      {
        title: 'chat_queue_settings',
        to: '/chats/queue',
        toFixed: '/qc-settings/chats/queue',
        scope: Roles.QA_CHAT_QUEUE_SETTINGS,
        icon: 'mdi-cog-refresh',
      },
    ],
  },
  {
    group: '/qc-v2',
    icon: 'mdi-text-box-check',
    title: 'qc-v2',
    scope: 'qa:*',
    children: [
      {
        title: 'chat_archive',
        to: '/chats/archive',
        toFixed: '/qc-v2/chats/archive',
        scope: Roles.QA_CHAT_REVIEW,
        icon: 'mdi-archive-outline',
      },
      {
        title: 'chat_queue',
        to: '/chats/queue',
        toFixed: '/qc-v2/chats/queue',
        scope: Roles.QA_CHAT_REVIEW,
        icon: 'mdi-tray-full',
      },
      {
        title: 'tickets_archive',
        to: '/tickets/archive',
        toFixed: '/qc-v2/tickets/archive',
        scope: Roles.QA_TICKET_REVIEW,
        icon: 'mdi-ticket-confirmation-outline',
      },
      {
        title: 'tickets_queue',
        to: '/tickets/queue',
        toFixed: '/qc-v2/tickets/queue',
        scope: Roles.QA_TICKET_REVIEW,
        icon: 'mdi-ticket-confirmation-outline',
      },
      {
        title: 'feedbacks',
        to: '/feedbacks',
        toFixed: '/qc-v2/feedbacks',
        scope: Roles.QA_FEEDBACK_READ,
        icon: 'mdi-message-bookmark-outline',
      },
      {
        title: 'escalations',
        to: '/escalations',
        toFixed: '/qc-v2/escalations',
        scope: Roles.QA_ESCALATION_READ,
        icon: 'mdi-clipboard-arrow-up-outline',
      },
      {
        title: 'statistics',
        to: '/statistics',
        toFixed: '/qc-v2/statistics',
        scope: Roles.QA_STATISTICS_READ,
        icon: 'mdi-chart-line',
      },
    ],
  },
  {
    group: '/qc-settings-v2',
    icon: 'mdi-text-box-check',
    title: 'qc_settings_v2',
    scope: Roles.QA_MANAGER,
    children: [
      {
        title: 'scores',
        to: '/scores',
        toFixed: '/qc-settings-v2/scores',
        scope: Roles.QA_SCORE_TYPE_READ,
        icon: 'mdi-book-open-page-variant-outline',
      },
      {
        title: 'tags',
        to: '/tags',
        toFixed: '/qc-settings-v2/tags',
        scope: Roles.QA_TAG_READ,
        icon: 'mdi-tag-outline',
      },
      {
        title: 'ticket-cron-config',
        to: '/ticket-cron-config',
        toFixed: '/qc-settings-v2/ticket-cron-config',
        scope: Roles.QA_TICKET_REVIEW,
        icon: 'mdi-cog-refresh',
      },
    ],
  },
  {
    group: '/dossiers',
    icon: 'mdi-account-tie-hat',
    title: 'agent-profiles',
    scope: 'dossier:*',
    children: [
      {
        title: 'all-agents',
        to: '/dossiers',
        toFixed: '/dossiers/',
        scope: Roles.DOSSIER_USER_READ,
        icon: 'mdi-account-multiple',
      },
      {
        title: 'add-agent',
        to: '/add',
        toFixed: '/dossiers/add',
        scope: Roles.DOSSIER_USER_CREATE,
        icon: 'mdi-account-plus',
      },
      {
        title: 'all-teams',
        to: '/teams',
        toFixed: '/dossiers/teams',
        scope: Roles.DOSSIER_TEAM_READ,
        icon: 'mdi-account-group',
      },
      {
        title: 'create-team',
        to: '/teams/create',
        toFixed: '/dossiers/teams/create',
        scope: Roles.DOSSIER_TEAM_CREATE,
        icon: 'mdi-account-multiple-plus',
      },
      {
        title: 'review-categories',
        to: '/review-categories',
        toFixed: '/review-categories',
        scope: Roles.DOSSIER_FEEDBACK_READ,
        icon: 'mdi-account-multiple-plus',
      },
    ],
  },
  {
    group: '/users',
    icon: 'mdi-account',
    title: 'users',
    scope: 'user:*',
    children: [
      {
        title: 'list_users',
        to: '/',
        scope: Roles.USER_USERS_READ,
        icon: 'mdi-account-details',
      },
      {
        title: 'create_user',
        to: '/create',
        scope: Roles.USER_USERS_CREATE,
        icon: 'mdi-account-multiple-plus-outline',
      },
      {
        title: 'user_roles',
        toFixed: '/roles',
        scope: Roles.USER_ROLES_READ,
        icon: 'mdi-account-lock-outline',
      },
      {
        title: 'user_departments',
        toFixed: '/departments',
        scope: Roles.USER_DEPARTMENTS_READ,
        icon: 'mdi-account-group',
      },
    ],
  },
  {
    group: '/calendar',
    icon: 'mdi-calendar-month',
    title: 'calendar',
    scope: 'calendar:*',
    children: [
      {
        title: 'calendar_shifts',
        to: '/shifts',
        scope: Roles.CALENDAR_SHIFTS_READ,
        icon: 'mdi-calendar-clock',
      },
      {
        title: 'calendar_manage_shifts',
        to: '/shifts/manage',
        scope: Roles.CALENDAR_SHIFTS_CREATE,
        icon: 'mdi-calendar-clock',
      },
      {
        title: 'calendar_events',
        to: '/events',
        scope: Roles.CALENDAR_SHIFTS_READ,
        icon: 'mdi-calendar-clock',
      },
      {
        title: 'calendar_manage_events',
        to: '/events/manage',
        scope: Roles.CALENDAR_SHIFTS_CREATE,
        icon: 'mdi-calendar-clock',
      },
    ],
  },
  {
    group: '/leaves',
    icon: 'mdi-account-minus',
    title: 'leaves',
    scope: 'calendar:*',
    children: [
      {
        title: 'new_leave',
        to: '/new',
        scope: Roles.CALENDAR_LEAVE_CREATE,
        icon: 'mdi-calendar-plus',
      },
      {
        title: 'my_leaves',
        to: '/my',
        scope: Roles.CALENDAR_LEAVE_CREATE,
        icon: 'mdi-calendar-search',
      },
      {
        title: 'all_leaves',
        to: '/all',
        scope: Roles.CALENDAR_LEAVE_CREATE,
        icon: 'mdi-account-multiple-minus',
      },
      {
        title: 'employees_leaves',
        to: '/employees',
        scope: Roles.CALENDAR_LEAVE_CREATE,
        icon: 'mdi-account-search',
      },
      {
        title: 'archive',
        to: '/archive',
        scope: Roles.CALENDAR_LEAVE_CREATE,
        icon: 'mdi-archive',
      },
      {
        title: 'approvers',
        to: '/approvers',
        scope: Roles.CALENDAR_DEFAULT_APPROVERS,
        icon: 'mdi-account-check-outline',
      },
    ],
  },
  {
    group: '/internal-tickets',
    icon: 'mdi-alarm-light-outline',
    title: 'internal_tickets',
    scope: 'server:*',
    children: [
      {
        title: 'bug_reports',
        to: '/bugs',
        scope: Roles.SERVER_SERVER_READ,
        icon: 'mdi-bug-outline',
      },
      {
        title: 'feature_requests',
        to: '/features',
        scope: Roles.SERVER_SERVER_CREATE,
        icon: 'mdi-file-table',
      },
      {
        title: 'archive',
        to: '/tickets/completed',
        scope: Roles.SERVER_SERVER_READ,
        icon: 'mdi-archive-outline',
      },
      {
        title: 'settings',
        to: '/settings',
        scope: Roles.SERVER_SERVER_READ,
        icon: 'mdi-settings-helper',
      },

    ],
  },
  {
    group: '/action-logs',
    icon: 'mdi-list-box-outline',
    title: 'action_logs',
    scope: 'logs:*',
    children: [
      {
        title: 'action_logs',
        to: '/',
        scope: Roles.ACTION_LOGS_READ,
        icon: 'mdi-list-box-outline',
        toFixed: '/action-logs',
      },
    ],
  },
  {
    group: '/files-manager',
    icon: 'mdi-clipboard-file',
    title: 'internal_file_manager',
    scope: 'ifm:*',
    children: [
      {
        title: 'browse_files',
        to: '/',
        icon: 'mdi-file-find',
        scope: Roles.IFM_BROWSE,
      },
      {
        title: 'folders',
        to: '/folders',
        icon: 'mdi-folder',
      },
    ],
  },
])
